import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import styles from './styles.css'

class Terms extends PureComponent {
  static propTypes = {
    disableNav: PropTypes.func.isRequired,
  }

  componentWillMount() {
    this.props.disableNav()
  }

  render() {
    return (
      <div className={classnames(styles.Grid, styles.main)}>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.h2)}>
          Terms and Conditions
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.subHeadings)}>
          Introduction
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.paragraph)}>
          These Website Standard Terms and Conditions written on this webpage shall manage your use
          of this website. These Terms will be applied fully and affect your use of this Website. By
          using this Website, you agreed to accept all terms and conditions written in here. You
          must not use this Website if you disagree with any of these Website Standard Terms and
          Conditions. Minors or people below 18 years old are not allowed to use this Website. These
          Website Terms and Conditions also apply to any online portal provided as a companion or
          tutorial in conjunction with this Website and referred to as Online Portal(s) in this
          document.
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.subHeadings)}>
          Intellectual Property Rights
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.paragraph)}>
          Other than the content you own, under these Terms, OnTheGo Technologies LLC and/or its
          licensors own all the intellectual property rights and materials contained in this
          Website. You are granted limited license only for purposes of viewing the material
          contained on this Website and using the functionality provided by this Website.
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.subHeadings)}>
          Restrictions
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.paragraph)}>
          You are specifically restricted from all of the following
          <ul className={classnames(styles['list-item'])}>
            <li className={classnames(styles['list-item'])}>
              - publishing any Website material in any other media
            </li>
            <li className={classnames(styles['list-item'])}>
              - selling, sublicensing and/or otherwise commercializing any Website material
            </li>
            <li className={classnames(styles['list-item'])}>
              - publicly performing and/or showing any Website material without prior and written
              consent of OnTheGo Technologies, LLC.
            </li>
            <li className={classnames(styles['list-item'])}>
              - using this Website in any way that is or may be damaging to this Website
            </li>
            <li className={classnames(styles['list-item'])}>
              - using this Website in any way that impacts user access to this Website
            </li>
            <li className={classnames(styles['list-item'])}>
              - using this Website contrary to applicable laws and regulations, or in any way may
              cause harm to the Website, or to any person or business entity
            </li>
            <li className={classnames(styles['list-item'])}>
              - engaging in any data mining, data harvesting, data extracting or any other similar
              activity in relation to this Website
            </li>
            <li className={classnames(styles['list-item'])}>
              - using this Website to engage in any advertising or marketing
            </li>
          </ul>
          Certain areas of this Website are restricted from being access by you and OnTheGo
          Technologies LLC may further restrict access by you to any areas of this Website, at any
          time, in absolute discretion. Any user ID and password you may have for this Website are
          confidential and you must maintain confidentiality as well.
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.subHeadings)}>
          Your Content
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.paragraph)}>
          In these Website Standard Terms and Conditions, “Your Content” shall mean any audio, video
          text, images or other material you choose to display on this Website and/or Online
          Portals. By displaying Your Content, you grant OnTheGo Technologies LLC a non-exclusive,
          worldwide irrevocable, sub-licensable license to use, reproduce, adapt, publish, translate
          and distribute it in any and all media. Your Content must be your own and must not be
          invading any third-party’s rights. OnTheGo Technologies LLC reserves the right to remove
          any of Your Content from this Website at any time without notice.
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.subHeadings)}>
          No Warranties
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.paragraph)}>
          This Website is provided “as is,” with all faults, and OnTheGo Technologies LLC express no
          representations or warranties, of any kind related to this Website, the Online Portals, or
          the materials contained on this Website. Also, nothing contained on this Website shall be
          interpreted as advising you.
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.subHeadings)}>
          Limitation of Liability
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.paragraph)}>
          In no event shall OnTheGo Technologies LLC, nor any of its officers, directors and
          employees, shall be held liable for anything arising out of or in any way connected with
          your use of this Website and/or Online Portals whether such liability is under contract.
          OnTheGo Technologies LLC, including its officers, directors, and employees shall not be
          held liable for any indirect, consequential or special liability arising out of or in any
          way related to your use of this Website.
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.subHeadings)}>
          Imdemnification
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.paragraph)}>
          You hereby indemnify to the fullest extent OnTheGo Technologies LLC from and against any
          and/or all liabilities, costs, demands, causes of action, damages and expenses arising in
          any way related to your breach of any of the provisions of these Terms.
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.subHeadings)}>
          Severability
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.paragraph)}>
          If any provision of these Terms is found to be invalid under any applicable law, such
          provisions shall be deleted without affecting the remaining provisions herein.
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.subHeadings)}>
          Variation of Terms
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.paragraph)}>
          OnTheGo Technologies LLC is permitted to revise these Terms at any time as it sees fit,
          and by using this Website and/or Online Portals you are expected to review these Terms on
          a regular basis.
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.subHeadings)}>
          Assignment
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.paragraph)}>
          The OnTheGo Technologies LLC is allowed to assign, transfer, and subcontract its rights
          and/or obligations under these Terms without any notification. However, you are not
          allowed to assign, transfer, or subcontract any of your rights and/or obligations under
          these Terms.
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.subHeadings)}>
          Entire Agreement
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.paragraph)}>
          These Terms constitute the entire agreement between OnTheGo Technologies LLC and you in
          relation to your use of this Website, and supersede all prior agreements and
          understandings.
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.subHeadings)}>
          Governing Law & Jurisdiction
        </div>
        <div className={classnames(styles['Grid-cell'], styles['u-size1of1'], styles.paragraph)}>
          These Terms will be governed by and interpreted in accordance with the laws of the State
          of CA, and you submit to the non-exclusive jurisdiction of the state and federal courts
          located in CA for the resolution of any disputes.
        </div>
      </div>
    )
  }
}

export default connect(
  null,
  null
)(Terms)



// WEBPACK FOOTER //
// ./src/views/terms/index.js